// External Imports
import { BiSolidCar, BiSolidCarMechanic } from "react-icons/bi";
import {
  MdBookmarkAdded,
  MdBookmarkRemove,
  MdEditDocument,
  MdLocationOff,
  MdLocationOn,
  MdShield,
} from "react-icons/md";
import { UtilityContext } from "../../context/util-context";
import { useContext } from "react";

// Internal Imports

/** ========================================================================
 * * VehicleFlags Component
 * This component renders a component that displays vehicle's status summary.
 * ========================================================================== */

export default function VehicleFlags({ vehicle = {}, clickable = false }) {
  const { navigate } = useContext(UtilityContext);

  const clickHandler = (action, e) => {
    if (clickable) {
      if (action) action();
      else navigate(`/vehicles/info?id=${vehicle.id}`, e);
    }
  };

  return (
    <div
      onClick={(e) =>
        !clickable && navigate(`/vehicles/info?id=${vehicle.id}`, e)
      }
      className={
        (!clickable ? "cursor-pointer hover:bg-stone-800 rounded-md " : "") +
        "flex justify-around space-x-4"
      }
    >
      {vehicle.status === "available" ? (
        <BiSolidCar
          onClick={(e) => clickHandler(false, e)}
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-green-600"
          }
          title="Vehicle has no issues."
        />
      ) : vehicle.status === "maintenance" ? (
        <BiSolidCarMechanic
          onClick={(e) => clickHandler(() => navigate(`/maintenance?query=${vehicle.id}`), e)}
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-yellow-500"
          }
          title="Vehicle has issues."
        />
      ) : (
        <BiSolidCarMechanic
          onClick={(e) => clickHandler(false, e)}
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-red-600"
          }
          title="Vehicle is not available."
        />
      )}
      {vehicle.trackerId ? (
        <MdLocationOn
          onClick={(e) => clickHandler(false, e)}
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-green-600"
          }
          title="Vehicle has a tracker"
        />
      ) : (
        <MdLocationOff
          onClick={(e) => clickHandler(false, e)}
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-red-600"
          }
          title="Vehicle has no tracker"
        />
      )}
      {vehicle.application?.insurance ||
      new Date(vehicle.application?.insuranceExp) > new Date() ? (
        <MdShield
          onClick={(e) =>
            clickHandler(
              () => window.open(vehicle.application?.insurance, "_blank"),
              e
            )
          }
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-green-600"
          }
          title="Vehicle insurance available"
        />
      ) : (
        <MdShield
          className="w-5 h-5 text-red-600"
          title="Vehicle insurance not available or expired"
        />
      )}
      {vehicle.application?.registeration ||
      new Date(vehicle.application?.registerationExp) > new Date() ? (
        <MdEditDocument
          onClick={(e) =>
            clickHandler(
              () => window.open(vehicle.application?.registeration, "_blank"),
              e
            )
          }
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-green-600"
          }
          title="Vehicle registeration available"
        />
      ) : (
        <MdEditDocument
          className="w-5 h-5 text-red-600"
          title="Vehicle registeration not available or expired"
        />
      )}
      {vehicle.tollTagId ? (
        <MdBookmarkAdded
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-green-600"
          }
          title="Vehicle has a Toll Tag"
        />
      ) : (
        <MdBookmarkRemove
          className={
            (clickable ? "cursor-pointer hover:opacity-80 " : "") +
            "w-5 h-5 text-red-600"
          }
          title="Vehicle has no Toll Tag"
        />
      )}
    </div>
  );
}
